module.exports = __webpack_public_path__ + "img/city_img.1cd6f5af.png";